<template>
  <div class="xy-qrcode">
    <qr-code :value="props.content" :width="width" :logo="props.logo"></qr-code>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, watch } from 'vue'
import { info, defaultProps } from './config'
import QrCode from './components/qrcode/qrcode.vue'
import { debounce } from 'lodash'

defineOptions({ name: info.name })
const props = defineProps(defaultProps)
const width = ref()

const updateWidth = () => {
  const element = props.element.uuid ? document.getElementById(props.element.uuid) : null
  if (element && element.clientWidth) {
    width.value = element.clientWidth
  }
}

// 使用 lodash 的 debounce 创建防抖函数
const debouncedUpdateWidth = debounce(updateWidth, 300)

watch(() => props.element.style, () => {
  debouncedUpdateWidth()
}, { immediate: true, deep: true })

onMounted(() => {
  updateWidth()
})

onUnmounted(() => {
  debouncedUpdateWidth.cancel() // 取消防抖
})
</script>

<style lang="scss" scoped>
.xy-qrcode {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>